export function openOnlineService() {
  window.dispatchEvent(new Event('hopegoo:open-online-service'))
}
